<template>
  <div>
    <div class="card card-custom gutter-b example example-compact">
      <div class="card-header">
        <div class="card-title">
          <router-link to="/admin/producers" class="mr-5">
            <b-icon icon="arrow-left" scale="1.5"></b-icon>
          </router-link>
          <h3>Produkte verwalten</h3>
        </div>
      </div>
      <div class="card-body">
        <table class="provider-info-tbl">
          <tr>
            <td>Händler Name:</td>
            <td>{{ userData.first_name + " " + userData.last_name }}</td>
          </tr>
          <tr>
            <td>E-Mail:</td>
            <td>{{ userData.email }}</td>
          </tr>
          <tr>
            <td>Telefonnummer:</td>
            <td>{{ userData.mobile_no ? userData.mobile_no : "-" }}</td>
          </tr>
          <tr v-if="userData.producer_detail && userData.producer_detail.brand_name">
            <td>Firmenname:</td>
            <td>{{ userData.producer_detail.brand_name }}</td>
          </tr>
        </table>
        <div class="table-responsive mt-5">
          <v-simple-table class="record-table">
            <thead>
              <tr>
                <th class="text-center align-middle" width="8%">Seriennummer</th>
                <th
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'product_name',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Produkt Name
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'product_name'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'product_name' &&
                        filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'product_name' &&
                        filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <!--                <th class="text-center align-middle">Description</th>-->
                <!--<th
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'address',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Address
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'address'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'address' &&
                        filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'address' &&
                        filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>-->
                <!--<th
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'price',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Price
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'price'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'price' && filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'price' && filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>-->
                <th class="text-center align-middle" width="15%">Einheit</th>
                <th class="text-center align-middle">Status</th>
                <!-- <th class="text-center align-middle">Thumbnail</th> -->
                <th class="text-center align-middle" width="10%">Aktionen</th>
              </tr>
            </thead>
            <tr>
              <td></td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchNameKey"
                    solo
                    label="Namen suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <!--<td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchAddressKey"
                    solo
                    label="Search address..."
                    clearable
                  ></v-text-field>
                </div>
              </td>-->
              <td>
                <div class="search-input-div">
                  <!--<v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchPriceKey"
                    solo
                    label="Search price..."
                    clearable
                  ></v-text-field>-->
                  <v-select
                  :items="unitsList"
                  v-model="searchUnitKey"
                  item-text="unit"
                  item-value="id"
                  label="Einheit suchen..."
                  solo
                  clearable
                />
                </div>
              </td>
              <td>
                <v-select
                  :items="statusItems"
                  v-model="searchStatusKey"
                  item-text="title"
                  item-value="value"
                  label="Status suchen..."
                  solo
                  clearable
                />
              </td>
              <td></td>
            </tr>
            <tbody v-if="products.length">
              <tr v-for="(product, i) in products" :key="product.id">
                <td class="align-middle">
                  {{ i + 1 }}
                </td>
                <td class="align-middle">
                  {{ product.product_name.length > 30 ? product.product_name.substr(0, 30) + "..." : product.product_name }}
                </td>
                <!--<td class="align-middle">
                  {{ property.address }}
                </td>-->
                <td class="align-middle">
                  {{ product.unit_detail ? product.unit_detail.unit : "-" }}
                </td>
                <td class="align-middle">
                  {{product.is_status == 0
                      ? "Entwurf"
                      : product.is_status == 2 && product.is_block == 1
                      ? "Online"
                      : "Offline"
                  }}
                </td>
                <td class="align-middle text-center icon-wrapper-block">
                  <a
                    @click="goToEdit(product.id)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="search"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Details anzeigen</span>
                    </v-tooltip>
                  </a>
                  <a v-if="product.is_status == 2  && product.is_block == '1'"  @click="changeStatus(product.id, product.is_status, product.is_block)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Online</span>
                    </v-tooltip>
                  </a>
                  <a v-if="product.is_status == 3 && product.is_block == '1'" @click="changeStatus(product.id, product.is_status, product.is_block)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye-slash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Offline</span>
                    </v-tooltip>
                  </a>
                  <a v-else-if="product.is_status == 2 && product.is_block == '0'" @click="changeStatus(product.id, product.is_status, product.is_block)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye-slash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Offline</span>
                    </v-tooltip>
                  </a>
                  <a v-else-if="product.is_status == 3" @click="changeStatus(product.id, product.is_status, product.is_block)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye-slash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Offline</span>
                    </v-tooltip>
                  </a>
                  <a v-if="product.is_status == 0 || product.is_status == 1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="hourglass"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Entwurf</span>
                    </v-tooltip>
                  </a>
                  <a
                    v-if="product.is_status == 1"
                    @click="changeStatus(product.id, product.is_status, product.is_block)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">                       
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="hourglass"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Freigabe offen</span>
                    </v-tooltip>
                  </a>
                  <a @click="deleteProduct(product.id)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="trash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Löschen</span>
                    </v-tooltip>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="loading_products" class="loading-tbody">
              <td colspan="10">
                Wird geladen...
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </td>
            </tbody>
            <tbody v-else class="loading-tbody">
              <tr>
                <td colspan="10">Keine Einträge gefunden</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="d-flex pagination-block">
            <b-pagination
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total-rows="pagination.paginationRows"
              prev-text="Voriges"
              next-text="Nächstes"
              first-number
              last-number
              @change="paginationChange"
            >
              <template #prev-text
                ><span
                  ><b-icon
                    icon="chevron-left"
                    aria-hidden="true"
                  ></b-icon></span
              ></template>
              <template #next-text
                ><span
                  ><b-icon
                    icon="chevron-right"
                    aria-hidden="true"
                  ></b-icon></span
              ></template>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="showFileModal"
      class="file-modal"
      centered
      hide-footer
      resizable
    >
      <div v-if="modalFile">
        <div>
          <b-img :src="modalFile" class="modal-image"></b-img>
        </div>
      </div>
    </b-modal>
    <v-dialog v-model="statusDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Status wirklich ändern?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="changeStatusRecord(statusRecordId, newStatus)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Eintrag wirklich löschen?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            No
          </v-btn>
          <v-btn
            type="submit"
            @click="deleteRecord(deleteRecordId)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="producres" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import HtmlClass from "@/core/services/htmlclass.service";
//import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Notifications from "vue-notification";
//import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";

Vue.use(Notifications);

export default {
  name: "ProducerProducts",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.producerId = this.$route.params.id;
      this.getproducts();
      const unitsPromise = this.getProductUnits();
      Promise.all([
        unitsPromise,
      ]);
    }
  },
  data() {
    return {
      loading_products: true,
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      searchNameKey: "",
      //searchAddressKey: "",
      //searchPriceKey: "",
      searchStatusKey: "",
      searchUnitKey: "",
      producerId: "",
      userId: null,
      showFileModal: false,
      modalFile: null,
      products: [],
      userData: [],
      statusItems: [
        {
          title: "Entwurf",
          value: "0",
        },
        {
          title: "Online",
          value: "2",
        },
        {
          title: "Offline",
          value: "3",
        },
      ],
      unitsList: [],
      deleteRecordId: null,
      statusDialog: false,
      deleteDialog: false,
      statusRecordId: null,
      yesActionLoading: false,
      disabledCancel: false,
      newStatus: null,
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
    };
  },
  components: {
    // 'money-format': MoneyFormat
  },
  watch: {
    searchNameKey: {
      handler: function (val, oldVal) {
        this.products = [];
        this.loading_products = true;
        this.getproducts();
      },
      deep: true,
    },
    /*searchAddressKey: {
      handler: function (val, oldVal) {
        this.properties = [];
        this.loading_products = true;
        this.getproducts();
      },
      deep: true,
    },*/
    /*searchPriceKey: {
      handler: function (val, oldVal) {
        this.products = [];
        this.loading_products = true;
        this.getproducts();
      },
      deep: true,
    },*/
    searchStatusKey: {
      handler: function (val, oldVal) {
        this.products = [];
        this.loading_products = true;
        this.getproducts();
      },
      deep: true,
    },
    searchUnitKey: {
      handler: function (val, oldVal) {
        this.products = [];
        this.loading_products = true;
        this.getproducts();
      },
      deep: true,
    },
    
  },
  methods: {
    deleteProduct(id) {
      this.deleteDialog = true;
      this.deleteRecordId = id;
    },
    
    goToEdit(id) {
      this.$router.push({ path: '/admin/dealer-product-details/' + this.producerId + '/' + id, query: {redirect: 'dealer-listing'} });
    },
    encodeId(id) {
      var encodedId = btoa(id);
      return encodedId
    },
    hideModal() {
      this.statusDialog = false;
      this.yesActionLoading = false;
      this.deleteDialog = false;
    },
    clearInput(type) {
      switch (type) {
        case "name":
          this.searchNameKey = "";
          break;

        /*case "address":
          this.searchAddressKey = "";
          break;*/

        /*case "price":
          this.searchPriceKey = "";
          break;*/
      }
    },
    sortListing(orderCol, orderBy) {
      if (!this.loading_products) {
        this.products = [];
        this.filter.orderCol = orderCol;
        this.filter.orderBy = orderBy;
        this.pagination.currentPage = 1;
        this.loading_products = true;
        this.getproducts();
      }
    },
    openFileModal(file) {
      this.showFileModal = true;
      this.modalFile = file;
    },
    paginationChange() {
      this.products = [];
      this.loading_products = true;
      setTimeout(() => {
        this.getproducts();
      }, 100);
    },
    getProductUnits() {
      adminAPI
        .getProductUnits()
        .then((response) => {
          if (response.status == "success") {
            this.unitsList = response.data;                
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getproducts() {
      let data = {
        producer_id: this.$route.params.id,
        page: this.pagination.currentPage,
        search_name_field: this.searchNameKey,
        //search_address_field: this.searchAddressKey,
        //search_price_field: this.searchPriceKey,
        search_status_field: this.searchStatusKey,
        search_unit_field:this.searchUnitKey,
        per_page: this.pagination.perPage,
        sort_column: this.filter.orderCol,
        sort_type: this.filter.orderBy,
      };

      adminAPI
        .getProducerProducts(data)
        .then((response) => {
          if (response.status == "success") {
            this.products = response.data.product;
            this.pagination.paginationRows = response.count;
            this.userData = response.data.producer;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_products = false;
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_products = false;
            this.$notify({
              group: "producres",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_products = false;
          this.$notify({
            group: "producres",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    deleteproperty(id) {
      this.deleteDialog = true;
      this.deleteRecordId = id;
    },
    deleteRecord(id) {
      this.deleteDialog = false;
      this.deleteRecordId = null;
      axios
        .post("delete-product", { id: id })
        .then((response) => {
          var responseJson = response.data;
          if (responseJson.status == "success") {
            this.$notify({
              group: "producres",
              type: "success",
              position: "bottom right",
              text: responseJson.msg,
              duration: 5000,
            });
            this.pagination.currentPage = 1;
            this.getproducts();
          } else {
            this.$notify({
              group: "producres",
              type: "error",
              position: "bottom right",
              text: responseJson.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producres",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    changeStatus(id, status, is_block) {
      if(is_block == 1){
        if (status == 1) {
          this.newStatus = "2";
        } else if (status == 2) {
          this.newStatus = "3";
        } 
        else if (status == 3) {
          this.newStatus = "2";
        }
        this.statusDialog = true;
        this.statusRecordId = id;
      }
    },
    changeStatusRecord(id, status) {
      this.yesActionLoading = true;
      this.disabledCancel = true;

      adminAPI
        .statusProduct({ id: id, status: status })
        .then((response) => {
          if (response.status == "success") {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "producres",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.getproducts();
          } else {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "producres",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.statusDialog = false;
          this.statusRecordId = null;
          this.newStatus = null;
          this.yesActionLoading = false;
          this.disabledCancel = false;
          this.$notify({
            group: "producres",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.invite-btn {
  background-color: #3d5a80;
}

.invite-btn:hover {
  background-color: #002c47;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}
</style>